import React from "react";
import type { MenuListProps } from "@chakra-ui/react";
import { MenuList as MenuListChakra } from "@chakra-ui/react";
import { colors } from "../../../../../../theme/colors";
import { observer } from "mobx-react-lite";

const MenuList: React.FC<MenuListProps> = observer(({ children, ...rest }) => (
	<MenuListChakra
		border={"none"}
		borderRadius={"8px"}
		mt={"24px"}
		boxShadow={`0px 4px 4px 0px ${colors.shadow[300]}, 0px 4px 4px 0px ${colors.shadow[200]}, 0px 3px 14px 2px ${colors.shadow[100]}`}
		{...rest}
	>
		{children}
	</MenuListChakra>
));

export default MenuList;
